// extracted by mini-css-extract-plugin
module.exports = {"style-accordion-wrapper":"_3b_nHBLtre_0m8Z9nE2hA5","preLoaderShimmer":"_2bHeVl46q2IlTs4qaoH49l"};